import React from "react";
import { List, ListItem, Stack, Typography } from "@mui/material";
import { WorkshopInstanceShortDto } from "../../types/workshopTypes";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

/**
 * Interface for the props of the WorkshopPendingFeedbackOverview component
 * @property pendingFeedbackForWorkshopInstances - list of workshops for which the user has pending feedback
 */
interface WorkshopPendingFeedbackOverviewProps {
  pendingFeedbackForWorkshopInstances: WorkshopInstanceShortDto[];
}

/**
 * Component to display a list of workshops for which the user has pending feedback
 * @param pendingFeedbackForWorkshopInstances - list of workshops for which the user has pending feedback
 * @returns a list of workshops for which the user has pending feedback with links to the feedback form
 */
const WorkshopPendingFeedbackOverview = ({
  pendingFeedbackForWorkshopInstances,
}: WorkshopPendingFeedbackOverviewProps) => {
  return (
    <Stack direction={"column"}>
      <Typography fontWeight={"bold"}>
        {pendingFeedbackForWorkshopInstances.length > 1
          ? `Bitte gib dein Feedback für die folgenden ${pendingFeedbackForWorkshopInstances.length} Workshops ab:`
          : "Bitte gib dein Feedback für den folgenden Workshop ab:"}
      </Typography>
      <List sx={{ listStyleType: "square", listStylePosition: "outside", pl: 2 }}>
        {pendingFeedbackForWorkshopInstances.map((instance) => (
          <ListItem
            key={instance.workshopInstanceId}
            disablePadding
            sx={{ display: "list-item" }}
            component={Link}
            to={`/workshops/${instance.workshopId}/${instance.workshopInstanceId}/feedback`}
            state={{ workshopName: instance.workshopName }}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {instance.date ? (
              <Typography>
                {dayjs(instance.date).format("DD.MM.YYYY")}: {instance.workshopName}
              </Typography>
            ) : (
              <Typography>{instance.workshopName}</Typography>
            )}
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default WorkshopPendingFeedbackOverview;
